module.exports = __webpack_public_path__ + "static/media/2019_pgp-logo_pl.d7beb7da.png";